export default __webpack_public_path__ + "static/static-asset-threeBoltsWhite-5ca995a945d14925dc0224cb038e724b.svg";